import React from 'react';
import EditDialog from 'src/components/insigthFactory/editDialog/EditDialog';
import ResultsDialog from 'src/components/insigthFactory/resultsDialog/ResultsDialog';
import InsightDetails from 'src/components/insigthFactory/insightDetails/InsightDetails';

const Insight = (props) => {
  const {
    files,
    goBack,
    onEdit,
    insight,
    fetchUrl,
    unidades,
    formEdit,
    openEdit,
    openResult,
    permitValue,
    onSubmitEdit,
    onOpenResult,
    onChangeInputs,
    onCloseDialogs,
    onDeleteInsight,
    handleDeleteFile,
    onChangeResults,
    onSubmitResult,
    formResult,
    onDeleteFile,
    onLike,
    onPostImage,
    insightImg,
  } = props;

  return (
    <>
      <EditDialog
        files={files}
        formEdit={formEdit}
        openDialog={openEdit}
        handleAcept={onSubmitEdit}
        onCloseDialog={onCloseDialogs}
        onChangeInputs={onChangeInputs}
        handleDeleteFile={handleDeleteFile}
      />
      <ResultsDialog
        onSubmitResult={onSubmitResult}
        form={formResult}
        openDialog={openResult}
        onCloseDialog={onCloseDialogs}
        onChangeInputs={onChangeResults}
        onDeleteFile={onDeleteFile}
      />
      <InsightDetails
        insightImg={insightImg}
        files={files}
        onLike={onLike}
        onEdit={onEdit}
        goBack={goBack}
        insight={insight}
        fetchUrl={fetchUrl}
        unidades={unidades}
        onPostImage={onPostImage}
        permitValue={permitValue}
        onOpenResult={onOpenResult}
        onDeleteInsight={onDeleteInsight}
      />
    </>
  );
};

export default Insight;
